import { createAction, createSlice } from '@reduxjs/toolkit';

export const getPatientRxMedicationsById = createAction('RxMedications/getPatientRxMedicationsById');
export const updatePatientRxMedicationsById = createAction('RxMedications/updatePatientRxMedicationsById');
export const createPatientRxMedications = createAction('RxMedications/createPatientRxMedications');
export const getPatientsActiveAllergies = createAction('RxMedications/getPatientsActiveAllergies');
export const getPatientsCurrentMedications = createAction('RxMedications/getPatientsCurrentMedications');
export const getAppointmentMedicationsById = createAction('RxMedications/getAppointmentMedicationsById');

const rxMedications = createSlice({
  name: 'RxMedications',
  initialState: {
    newMedications: [],
    activePatientRxMedications: [],
    activeAllergies: [],
    activeMedicines: [],
    activeAppointmentRxMedications: [],
    medicationStep: 0,
  },
  reducers: {
    getPatientRxMedicationsByIdSuccess(state, action) {
      const { data } = action.payload;
      state.activePatientRxMedications = data;
    },
    getPatientsActiveAllergiesSuccess(state, action) {
      const { data } = action.payload;
      state.activeAllergies = data;
    },
    getPatientsCurrentMedicationsSuccess(state, action) {
      const { data } = action.payload;
      state.activeMedicines = data;
    },
    getAppointmentMedicationsByIdSuccess(state, action) {
      const { data } = action.payload;
      state.activeAppointmentRxMedications = data;
    },
    addNewMedication(state, action) {
      const { data } = action.payload;
      state.newMedications.push(data);
    },
    deleteAddedMedication(state, action) {
      const { medicationId } = action.payload;
      state.newMedications = state.newMedications.filter(med => med.medicationId !== medicationId);
    },
    resetRxMedicationValues(state, action) {
      state.newMedications = [];
      state.medicationStep = 0;
    },
    showMedicationSummary(state, action) {
      state.medicationStep = 1;
    },
    populateMedicationFromChartImport(state, action) {
      const { data } = action.payload;
      state.newMedications = data;
    },
    markMedicineForDeletion(state, action) {
      const { medicationId } = action.payload;
      state.newMedications = state.newMedications.map(med => {
        if (med.medicationId === medicationId) {
          return {
            ...med,
            markForDeletion: true,
          };
        }
        return med;
      });
    },
  },
});

export const {
  getPatientRxMedicationsByIdSuccess,
  getPatientsActiveAllergiesSuccess,
  getPatientsCurrentMedicationsSuccess,
  getAppointmentMedicationsByIdSuccess,
  addNewMedication,
  deleteAddedMedication,
  resetRxMedicationValues,
  showMedicationSummary,
  populateMedicationFromChartImport,
  markMedicineForDeletion,
} = rxMedications.actions;

export default rxMedications.reducer;
